
import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import { Popover } from 'antd';

export default class ColorSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pickerVisible: false,
            selectColor: props.value || props.defaultValue || 'rgba(255,255,255,1)',
            elementId: 'color-editor' + Math.random().toString().substring(3)
        }
    }
    componentDidMount() {
        this._blankClick = this.blankClick.bind(this);
        document.addEventListener('click', this._blankClick);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value === this.props.value)
            return;

        this.setState({ selectColor: nextProps.value });
    }

    showPicker() {
        this.setState({
            pickerVisible: !this.state.pickerVisible
        })
    }
    blankClick(e) {
        if (this.isBlank(e.target)) {
            this.setState({
                pickerVisible: false
            });
        }
    }
    isBlank(node) {
        if (node) {
            if (node.id === `${this.state.elementId}`) {
                return false;
            } else {
                return this.isBlank(node.parentNode)
            }
        } else {
            return true;
        }
    }
    componentWillUnmount() {
        document.removeEventListener('click', this._blankClick);
    }
    render() {
        return (
            <Popover placement="bottomLeft" title={"颜色选择器"} content={(
                <SketchPicker color={this.state.selectColor} className="color-selector" style={{
                    width: 250,
                }} onChange={result => {
                    let color = `rgba(${result.rgb.r},${result.rgb.g},${result.rgb.b},${result.rgb.a})`;
                    this.setState({
                        selectColor: color
                    });
                    this.props.onChange && this.props.onChange(color);
                }} />
            )} trigger="click">

                <div id={this.state.elementId} className="freesia-color-editor" style={{ position: "relative", height: '100%', marginTop: 4 }}>
                    <div style={{
                        width: "30px",
                        border: "1px solid #ddd",
                        height: "30px",
                        position: "relative"
                    }} onClick={this.showPicker.bind(this)}>
                        <div style={{
                            position: "absolute",
                            top: "1px",
                            left: "1px",
                            bottom: "1px",
                            right: "1px",
                            background: this.state.selectColor
                        }}>

                        </div>
                    </div>

                </div>
            </Popover>
        );
    }
}